<template>
  <div>
    <!-- <v-layout wrap row pa-3>
      <v-flex xs6>
        <img :src="require('../assets/logo.png')" height="40" />
      </v-flex>
      <v-flex xs6 text-xs-right>
        <v-flex offset-xs6 offset-sm9>
          <v-select
            v-model="language"
            :items="languageList"
            class="pa-0 ma-0"
            hide-details
          ></v-select>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-flex pb-3 :class="{ 'px-3 ': $vuetify.breakpoint.smAndUp }">
      <v-divider></v-divider>
    </v-flex> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      languageList: [],
      languageListTH: [
        { text: 'ไทย', value: 'TH' },
        { text: 'อังกฤษ', value: 'EN' },
      ],
      languageListEN: [
        { text: 'Thai', value: 'TH' },
        { text: 'Eng', value: 'EN' },
      ],
    }
  },
  computed: {
    language: {
      get() {
        return this.$store.state.language
      },
      set(lang) {
        this.$store.commit('UPDATE_LANGUAGE', lang)
      },
    },
  },
  watch: {
    language(lang) {
      if (lang == 'TH') {
        this.languageList = this.languageListTH
      } else {
        this.languageList = this.languageListEN
      }
    },
  },
  mounted() {
    if (this.$store.state.language == 'TH') {
      this.languageList = this.languageListTH
    } else {
      this.languageList = this.languageListEN
    }
  },
}
</script>
